module.exports = __webpack_public_path__ + "static/media/add.c4f6e9e1.svg";